import { ManagedCarousel as g } from "./managedCarousel-1grIvnMA.mjs.js";
import { d as j, a as C, P as R } from "./useProductCardClick-CdzVOSUP.mjs.js";
import { R as k } from "./index-IEz1e_US.mjs.js";
import { j as s } from "./client-zRtiouUI.mjs.js";
import { c as y } from "./button-CaEAZQGx.mjs.js";
const N = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], w = y("loader-circle", N), z = ({
  podId: r,
  heading: c,
  headingTag: d = "h2",
  cioOptions: m,
  carouselProps: l,
  config: n,
  apiKey: p,
  version: u
}) => {
  const i = {
    apiKey: p,
    version: u
  }, {
    data: a,
    isLoading: x
  } = j(i, r, m), {
    handleRecommendationsClick: h
  } = C(i), f = (e, t, o) => {
    h(t, o, {
      pod_id: r,
      response: a?.response,
      result_id: a?.result_id
    });
  };
  return x || !a ? /* @__PURE__ */ s.jsx("div", {
    className: "flex items-center justify-center p-8",
    children: /* @__PURE__ */ s.jsx(w, {
      className: "size-8 bg-white animate-spin"
    })
  }) : a.response.total_num_results ? /* @__PURE__ */ s.jsxs("div", {
    children: [k.createElement(d, {
      className: "text-lg leading-7 md:text-2xl font-medium mb-4 text-gray-700"
    }, c ?? a?.response.pod?.display_name ?? "Recommendations"), /* @__PURE__ */ s.jsx(g, {
      ...l,
      children: a.response.results?.filter((e) => e.data).map((e, t) => /* @__PURE__ */ s.jsx(R, {
        showMfg: n?.show_manufacturer,
        showRating: n?.show_rating,
        onClick: (o, _) => f(o, _, t),
        css: {
          root: "p-4 m-2 mb-3 hover:shadow-custom",
          imageWrapper: "h-40",
          contentWrapper: "[&_a]:leading-5 [&_a]:text-sm"
        },
        data: {
          name: e.value || "",
          id: e.data?.id || "",
          ...e.data
        }
      }, e.itemId))
    })]
  }) : /* @__PURE__ */ s.jsx("div", {
    className: "flex items-center justify-center p-8",
    children: /* @__PURE__ */ s.jsx("p", {
      className: "text-gray-500",
      children: "No recommendations found"
    })
  });
};
export {
  z as CioRecommendations
};
